import { Component, Inject, OnInit, Optional } from '@angular/core';
import { CROSS } from 'src/defaultImages.js';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';

@Component({
  selector: 'app-select-restaurant',
  templateUrl: './select-restaurant.component.html',
  styleUrls: ['./select-restaurant.component.css'],
})
export class SelectRestaurantComponent implements OnInit {
  coupon: string = '';
  images = {
    CROSS: CROSS,
  };
  restList: any = [
    { name: 'r1', coupon: 'get1', amount_saved: 10 },
    { name: 'r2', coupon: 'get1', applied_coupon: 'get2', amount_saved: 5 },
  ];

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<any>
  ) {
    this.coupon = (this.data || {}).coupon;
  }

  ngOnInit() {}
  cancelClicked() {
    this.dialogRef.close({ status: 0, data: null, message: 'closed' });
  }
}
